import { render, staticRenderFns } from "./Bike.vue?vue&type=template&id=efffcbe0&lang=pug"
import script from "./Bike.vue?vue&type=script&lang=js"
export * from "./Bike.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports